module.exports = __webpack_public_path__ + "static/media/gettyimages-635967776-612x612.81fa0ba2.jpg";